import { useTranslation } from "react-i18next";
import { labelStyle } from "./eventSectionStyles.js";

/** Where to go, in the sidebar next to the tickets. The same `location`
 * and `address` the Event JSON-LD uses — moving them out of the hero
 * changes where they are shown, not what is published. */
export default function EventVenueCard({ event }) {
  const { t } = useTranslation();
  const { location, address, directionsUrl } = event;
  if (!location && !address) return null;

  const addressLine = address && [address.street, [address.postalCode, address.locality].filter(Boolean).join(" ")].filter(Boolean).join(", ");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        background: "var(--color-bg-raised)",
        borderRadius: "var(--radius-card-lg)",
        padding: "24px",
      }}
    >
      <span style={{ ...labelStyle, fontSize: "11px" }}>{t("events.venueLabel")}</span>
      <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
        {location && <span style={{ fontSize: "15px", color: "var(--color-cream)" }}>{location}</span>}
        {addressLine && <span style={{ fontSize: "13px", color: "rgba(254,250,239,0.6)" }}>{addressLine}</span>}
      </div>
      {directionsUrl && (
        <a href={directionsUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: "13px" }}>
          {t("events.directionsCta")}
        </a>
      )}
    </div>
  );
}
